// Extra admin tabs, one per workstream. Each tab component lives in its own file.
import type { ComponentType } from 'react';
import { GrowthTab } from './GrowthTab';
import { OrdersTab } from './OrdersTab';

export const extraAdminTabs: { key: string; label: string; component: ComponentType }[] = [
  { key: 'orders', label: 'Orders', component: OrdersTab },
  { key: 'growth', label: 'Growth', component: GrowthTab },
];
